import { render } from "./App.vue?vue&type=template&id=0ca766ca"
const script = {}

import exportComponent from "D:\\项目文件\\海外资讯\\海外资讯PC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__